import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "size-button__size" }

import { computed } from 'vue';

import useSizeDisplay from '@/composables/useSizeDisplay';
import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizeButton',
  props: {
  size: {
    type: Object,
    required: true,
  },
},
  emits: ['select'],
  setup(__props, { emit }) {

const props = __props





const { websiteText } = useWebsiteTexts();
const { getSizeName } = useSizeDisplay();

const stockStatus = computed(() => {
  if (!props.size.inStock)
    return (
      websiteText('productdetails_soldout').value || 'productdetails_soldout'
    );
  if (props.size.lowStock)
    return (
      websiteText('productdetails_lowstockwarning').value ||
      'productdetails_lowstockwarning'
    );
  return null;
});

function emitIfInStock() {
  emit('select', props.size);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["clean-button size-button", {
      'size-button__size--out-of-stock': !__props.size.inStock,
    }]),
    onClick: emitIfInStock
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(getSizeName)(__props.size.sizeName)), 1),
    (_unref(stockStatus))
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({ 'size-button__size-label--out-of-stock': !__props.size.inStock })
        }, _toDisplayString(_unref(stockStatus)), 3))
      : _createCommentVNode("", true)
  ], 2))
}
}

})